import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { handleStatus } from '../../../../shared/utils';
import { IResponseCCS0003 } from '../../../../shared/services/types/response';
import DeleteIcon from '@mui/icons-material/Delete';

interface CardCCS0003Props {
  ccsValue: IResponseCCS0003;
  handleOpenModal: (item?: IResponseCCS0003) => void;
  handleDeleteClick: (id: string) => void;
}

const CardCcs0003 = ({
  ccsValue,
  handleOpenModal,
  handleDeleteClick,
}: CardCCS0003Props) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom color="secondary.main">
          {ccsValue?.number_control_ccs}
        </Typography>
        <Typography variant="body2">
          Data de envio do Bacen:{' '}
          {moment(ccsValue?.date_time_bacen).format('DD/MM/yyyy')}
        </Typography>
        <Typography variant="body2">
          Criado em: {moment(ccsValue?.created_at).format('DD/MM/yyyy')}
        </Typography>
        <Typography variant="body2">
          ID Controle: {ccsValue?.number_control_if}
        </Typography>
        <Typography mt={1} textAlign={'end'} variant="body2">
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              px: 1.5,
              py: 0.2,
              borderRadius: 10,
              fontSize: 12,
              bgcolor:
                handleStatus(ccsValue?.status) === 'Criado'
                  ? '#4CAF50' // Verde mais escuro
                  : handleStatus(ccsValue?.status) === 'Pendente'
                    ? '#FFC107' // Amarelo mais escuro
                    : '#BDBDBD', // Cinza médio
              color: 'white',
            }}
          >
            {handleStatus(ccsValue?.status)}
          </Box>
        </Typography>
      </CardContent>
      <CardActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
        }}
      >
        <Button size="small" onClick={() => handleOpenModal()}>
          Detalhes
        </Button>
        {ccsValue?.status !== 'DONE' && (
          <Button
            color="error"
            size="small"
            onClick={() => handleDeleteClick(ccsValue?.id)}
          >
            <DeleteIcon />
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

export default CardCcs0003;
